import { createFileRoute } from "@tanstack/react-router";
import { ModuleDashboard } from "@/features/dashboards/ModuleDashboard";

// Manufacturing dashboard (PX-MFG-010): features/dashboards.
export const Route = createFileRoute("/_app/manufacturing/dashboard")({
  component: () => <ModuleDashboard module="manufacturing" />,
});
